<script>
  import { onMount } from 'svelte';
  import fetchAdminAPI from '../adminApi.js';

  export let authData;

  let tasks = [];
  let loading = true;
  let error = null;

  // Pagination
  let currentPage = 1;
  let pageSize = 10; // Бэкенд по умолчанию 20, но можно изменить
  let totalTasks = 0;

  // Modals and forms
  let showCreateModal = false;
  let showEditModal = false;
  let currentTask = null; // for editing
let newTask = {
    title: '',
    description: null,
    reward_spins: 0,
    reward_stars: 0,
    task_type: 'subscription', // <--- Вот оно, значение по умолчанию
    target_link: null,
    required_count: 1,
    is_active: true,
  };
  let editTaskData = {};

  onMount(() => {
    loadTasks();
  });

async function loadTasks() {
    loading = true;
    error = null;
    const params = { page: currentPage, pageSize: pageSize };
    // console.log("Fetching tasks with params:", params); // Можно оставить для отладки
    const result = await fetchAdminAPI('/tasks', 'GET', params, authData);
    
    // console.log("API Response for /tasks:", result); // Можно оставить для отладки

    if (result.success && result.data) { 
        // console.log("Raw data from API:", result.data); // Можно оставить для отладки
        tasks = result.data.data || [];    // БЫЛО: result.data.Data  СТАЛО: result.data.data
        totalTasks = result.data.total || 0; // БЫЛО: result.data.Total СТАЛО: result.data.total
        // console.log("Processed tasks:", tasks);
        // console.log("Total tasks count:", totalTasks);
    } else {
        error = (result && result.message) ? result.message : "Не удалось загрузить данные";
        if(result && result.data === null && result.success) {
             error = "Получены пустые данные от сервера";
        }
        tasks = [];
        totalTasks = 0;
        console.error("Error loading tasks:", error, "Full result:", result);
    }
    loading = false;
}

  function openCreateModal() {
    newTask = {
      title: '', description: null, reward_spins: 0, reward_stars: 0,
      task_type: 'subscription', target_link: null, required_count: 1, is_active: true,
    };
    showCreateModal = true;
  }

async function handleCreateTask() {
    const payload = { ...newTask }; // <--- Здесь task_type из newTask копируется в payload
    if (payload.description === "") payload.description = null;
    if (payload.target_link === "") payload.target_link = null;

    const result = await fetchAdminAPI('/tasks', 'POST', payload, authData);
    if (result.success) {
      showCreateModal = false;
      loadTasks(); // Reload list
    } else {
      alert(`Ошибка создания: ${result.message}`);
    }
  }

  function openEditModal(task) {
    currentTask = task;
    // Для PATCH запроса будем отправлять только измененные поля.
    // Поэтому editTaskData содержит только поля, которые можно редактировать.
    // Значения *string, если пустые, станут null при отправке.
    editTaskData = {
      title: task.Title,
      description: task.Description,
      reward_spins: task.RewardSpins,
      reward_stars: task.RewardStars,
      task_type: task.TaskType,
      target_link: task.TargetLink,
      required_count: task.RequiredCount,
      is_active: task.IsActive,
    };
    showEditModal = true;
  }

  async function handleUpdateTask() {
    if (!currentTask) return;

    // Собираем только те поля, которые были изменены или имеют значения
    // Фактически, бэкенд ожидает все поля, которые могут быть null
    const payload = {};
    // Сравнение не нужно, т.к. PATCH на бэкенде обрабатывает только переданные поля
    if (editTaskData.title !== undefined) payload.title = editTaskData.title;
    payload.description = editTaskData.description === "" ? null : editTaskData.description;
    if (editTaskData.reward_spins !== undefined) payload.reward_spins = Number(editTaskData.reward_spins);
    if (editTaskData.reward_stars !== undefined) payload.reward_stars = Number(editTaskData.reward_stars);
    if (editTaskData.task_type !== undefined) payload.task_type = editTaskData.task_type;
    payload.target_link = editTaskData.target_link === "" ? null : editTaskData.target_link;
    if (editTaskData.required_count !== undefined) payload.required_count = Number(editTaskData.required_count);
    if (editTaskData.is_active !== undefined) payload.is_active = editTaskData.is_active;


    const result = await fetchAdminAPI(`/tasks/${currentTask.ID}`, 'PATCH', payload, authData);
    if (result.success) {
      showEditModal = false;
      currentTask = null;
      loadTasks(); // Reload list
    } else {
      alert(`Ошибка обновления: ${result.message}`);
    }
  }

  async function handleDeleteTask(taskId) {
    if (!confirm(`Уверены, что хотите удалить задание ID: ${taskId}?`)) return;
    const result = await fetchAdminAPI(`/tasks/${taskId}`, 'DELETE', null, authData);
    if (result.success) {
      loadTasks(); // Reload list
    } else {
      alert(`Ошибка удаления: ${result.message}`);
    }
  }

  function changePage(newPage) {
    currentPage = newPage;
    loadTasks();
  }

  $: totalPages = Math.ceil(totalTasks / pageSize);
  $: taskTypes = ['subscription', 'view', 'other'];
</script>

<div class="tasks-admin-section">
  <div class="admin-section-header">
    <h2>Управление заданиями</h2>
    <div class="actions">
      <button class="admin-create" on:click={openCreateModal}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-right: 6px; vertical-align: text-bottom;">
          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
        </svg>
        Создать задание
      </button>
    </div>
  </div>

  <div class="admin-card">
    {#if loading}
      <div style="text-align:center; padding: 30px 0;">
        <div class="spinner-large" style="margin: 0 auto 10px auto;"></div>
        <p>Загрузка заданий...</p>
      </div>
    {:else if error}
      <p style="color: #d9534f; text-align:center; padding: 20px;">Ошибка: {error}</p>
    {:else if tasks.length === 0}
        <p style="text-align:center; padding: 20px; color: #555;">Заданий пока нет. Нажмите "Создать задание", чтобы добавить первое.</p>
    {:else}
      <div class="table-responsive-wrapper">
        <table class="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Заголовок</th>
              <th>Тип</th>
              <th>Спины</th>
              <th>Звезды</th>
              <th>Активно</th>
              <th style="text-align: right;">Действия</th>
            </tr>
          </thead>
          <tbody>
            {#each tasks as task (task.ID)}
              <tr>
                <td>{task.ID}</td>
                <td>{task.Title}</td>
                <td>{task.TaskType}</td>
                <td>{task.RewardSpins}</td>
                <td>{task.RewardStars}</td>
                <td>
                  <span class:status-active={task.IsActive} class:status-inactive={!task.IsActive}>
                    {task.IsActive ? 'Да' : 'Нет'}
                  </span>
                </td>
                <td class="admin-actions" style="text-align: right;">
                  <button class="admin-action-button admin-edit" on:click={() => openEditModal(task)}>Редакт.</button>
                  <button class="admin-action-button admin-delete" on:click={() => handleDeleteTask(task.ID)}>Удалить</button>
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
      {#if totalTasks > 0}
      <div class="pagination">
        <span class="page-info">Показано {tasks.length} из {totalTasks} заданий</span>
        <div class="page-controls">
          <button class="admin-action-button" on:click={() => changePage(currentPage - 1)} disabled={currentPage <= 1}>Назад</button>
          <span>Стр. {currentPage} из {totalPages}</span>
          <button class="admin-action-button" on:click={() => changePage(currentPage + 1)} disabled={currentPage >= totalPages}>Вперед</button>
          <select bind:value={pageSize} on:change={() => { currentPage = 1; loadTasks(); }} aria-label="Записей на странице">
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
      {/if}
    {/if}
  </div>
</div>

<!-- Create Task Modal -->
{#if showCreateModal}
  <div class="modal" on:click|self={() => showCreateModal = false} role="dialog" aria-modal="true" aria-labelledby="createTaskModalTitle">
    <div class="modal-content">
      <h3 id="createTaskModalTitle">Создать новое задание</h3>
      <form on:submit|preventDefault={handleCreateTask} class="admin-form">
        <label for="new-title">Заголовок:</label>
        <input id="new-title" type="text" bind:value={newTask.title} required>

        <label for="new-desc">Описание (необязательно):</label>
        <textarea id="new-desc" bind:value={newTask.description} rows="3"></textarea>

        <div style="display: flex; gap: 15px;">
            <div style="flex: 1;">
                <label for="new-spins">Награда (спины):</label>
                <input id="new-spins" type="number" bind:value={newTask.reward_spins} min="0" required>
            </div>
            <div style="flex: 1;">
                <label for="new-stars">Награда (звезды):</label>
                <input id="new-stars" type="number" bind:value={newTask.reward_stars} min="0" required>
            </div>
        </div>
        
        <label for="new-type">Тип задания:</label>
              
        <select id="new-type" bind:value={newTask.task_type}>
          {#each taskTypes as type (type)}
            <option value={type}>{type}</option>
          {/each}
        </select>

    

        <label for="new-link">Ссылка (необязательно):</label>
        <input id="new-link" type="url" bind:value={newTask.target_link} placeholder="https://...">

        <div style="display: flex; gap: 15px; align-items:center;">
            <div style="flex: 1;">
                <label for="new-count">Требуемое кол-во выполнений:</label>
                <input id="new-count" type="number" bind:value={newTask.required_count} min="1">
            </div>
            <label for="new-active" style="margin-top: 25px; display:flex; align-items:center;">
              <input id="new-active" type="checkbox" bind:checked={newTask.is_active} style="width: auto; height: auto;">
              <span style="margin-left: 5px;">Активно</span>
            </label>
        </div>
        
        <div class="form-actions">
          <button type="button" on:click={() => showCreateModal = false} class="admin-secondary">Отмена</button>
          <button type="submit" class="admin-primary">Создать</button>
        </div>
      </form>
    </div>
  </div>
{/if}

<!-- Edit Task Modal -->
{#if showCreateModal}
  <div class="modal" on:click|self={() => showCreateModal = false} role="dialog" aria-modal="true" aria-labelledby="createTaskModalTitle">
    <div class="modal-content">
      <h3 id="createTaskModalTitle">Создать новое задание</h3>
      <form on:submit|preventDefault={handleCreateTask} class="admin-form task-form-grid"> <!-- Добавляем класс -->
        <div class="form-field-title">
            <label for="new-title">Заголовок:</label>
            <input id="new-title" type="text" bind:value={newTask.title} required>
        </div>

        <div class="form-field-description">
            <label for="new-desc">Описание (необязательно):</label>
            <textarea id="new-desc" bind:value={newTask.description} rows="3"></textarea>
        </div>

        <!-- Обертка для полей в ряд, которая станет колонкой на мобильных -->
        <div class="form-row">
            <div class="form-field">
                <label for="new-spins">Награда (спины):</label>
                <input id="new-spins" type="number" bind:value={newTask.reward_spins} min="0" required>
            </div>
            <div class="form-field">
                <label for="new-stars">Награда (звезды):</label>
                <input id="new-stars" type="number" bind:value={newTask.reward_stars} min="0" required>
            </div>
        </div>
        
        <div class="form-field-task-type">
            <label for="new-type">Тип задания:</label>
            <select id="new-type" bind:value={newTask.task_type}>
              {#each taskTypes as type (type)}
                <option value={type}>{type}</option>
              {/each}
            </select>
        </div>

        <div class="form-field-target-link">
            <label for="new-link">Ссылка (необязательно):</label>
            <input id="new-link" type="url" bind:value={newTask.target_link} placeholder="https://...">
        </div>

        <div class="form-row">
            <div class="form-field">
                <label for="new-count">Требуемое кол-во выполнений:</label>
                <input id="new-count" type="number" bind:value={newTask.required_count} min="1">
            </div>
            <div class="form-field form-field-checkbox-container"> <!-- Обертка для чекбокса для выравнивания -->
                <label for="new-active" class="checkbox-label">
                  <input id="new-active" type="checkbox" bind:checked={newTask.is_active} class="form-checkbox-input">
                  <span class="checkbox-text">Активно</span>
                </label>
            </div>
        </div>
        
        <div class="form-actions">
          <button type="button" on:click={() => showCreateModal = false} class="admin-secondary">Отмена</button>
          <button type="submit" class="admin-primary">Создать</button>
        </div>
      </form>
    </div>
  </div>
{/if}


      
<style>

  :global(.task-form-grid) { /* Применяем к форме через :global или напрямую, если класс только здесь */
    display: grid;
    grid-template-columns: 1fr; /* По умолчанию одна колонка */
    gap: 0px 15px; /* Пробел между колонками (0 по вертикали т.к. поля управляют своим margin-top) */
  }
  :global(.task-form-grid .form-row) {
    display: grid;
    grid-template-columns: 1fr; /* Одна колонка на мобильных */
    gap: 0px 15px; /* Расстояние между полями в ряду */
  }

  @media (min-width: 500px) { /* Для экранов шире, чем типичный мобильный */
    :global(.task-form-grid .form-row) {
      grid-template-columns: 1fr 1fr; /* Две колонки для полей в ряду */
    }
  }

  :global(.task-form-grid .form-field-checkbox-container) {
    display: flex;
    align-items: center; /* Выравниваем чекбокс и текст по вертикали */
    /* Если label для чекбокса идет отдельно, а не оборачивает input+span: */
    /* margin-top: calc(12px + 6px + 1.2em); Примерный отступ сверху, чтобы выровнять с соседним инпутом */
    /* Лучше обернуть label+input в один div и управлять им */
    padding-top: 20px; /* Отступ для выравнивания с соседним инпутом у которого есть label */
  }
  :global(.task-form-grid .checkbox-label) {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 0; /* Убираем стандартный отступ label, если он для чекбокса */
  }
  :global(.task-form-grid .form-checkbox-input) {
    margin-right: 8px; /* Отступ между чекбоксом и текстом */
    width: auto; /* Возвращаем авто-ширину для чекбокса */
    height: auto;
    transform: scale(1.1); /* Немного увеличить сам чекбокс */
  }
  :global(.task-form-grid .checkbox-text) {
    font-size: 0.9em;
    color: #A6C5E1;
  }

  /* Классы для группировки полей, если нужно управлять их расположением в гриде */
  /* Например, если какие-то поля должны занимать всю ширину */
  /* :global(.task-form-grid .form-field-title),
  :global(.task-form-grid .form-field-description) {
     grid-column: 1 / -1; 
  } */
  .table-responsive-wrapper {
    overflow-x: auto;
  }
  .status-active, .status-inactive {
    padding: 4px 10px;
    border-radius: 16px;
    font-size: 0.8em;
    font-weight: 500;
    display: inline-block;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .status-active {
    color: #6EE7B7; /* Светло-зеленый */
    background-color: rgba(52, 211, 153, 0.15);
    border: 1px solid rgba(52, 211, 153, 0.3);
  }
  .status-inactive {
    color: #9CA3AF; /* Серый */
    background-color: rgba(156, 163, 175, 0.1);
    border: 1px solid rgba(156, 163, 175, 0.2);
  }
  /* Убираем дефолтные стрелки у input number в модалках (для Webkit) */
  :global(.modal-content input[type="number"]::-webkit-outer-spin-button),
  :global(.modal-content input[type="number"]::-webkit-inner-spin-button) {
    -webkit-appearance: none;
    margin: 0;
  }
  :global(.modal-content input[type="number"]) {
    -moz-appearance: textfield; /* Firefox */
  }
</style>

    